import get from 'lodash/get'
import merge from 'lodash/merge'

import QS from 'query-string'

export const createIdentityMap = (...keys) => merge(...keys.map(key => ({ [key]: key })))

export const getPossibleRecoveryToken = location => {
  const query = QS.parse(location.search)
  return get(query, 'confirmationCode', get(query, 'rc', ''))
}

export const getPossibleInviteToken = location => {
  const query = QS.parse(location.search)
  return get(query, 'key', get(query, 'it', ''))
}

export const getPasswordPolicyComplexity = policy => get(policy, 'complexity', {})
